'use client';
import { useTranslations } from 'next-intl';
import { Button } from '@/app/components/ui/button';
import { TEAM_BUTTON_BG_STYLE } from '../constants';
import { ConsultDialog } from './ConsultDialog';

/** 企业版兜底按钮：未上线企业 SKU 或占位场景使用 */
export const ConsultButton = () => {
  const t = useTranslations();
  return (
    <ConsultDialog>
      <Button
        className="h-12 w-full rounded-12 border-none font-medium text-sm text-white"
        style={TEAM_BUTTON_BG_STYLE}
      >
        {t('payments.plans.consultButton')}
      </Button>
    </ConsultDialog>
  );
};
